import * as React from 'react';
import { Checkbox } from '@cian/ui-kit/prev';
import { mergeStyles } from '@cian/utils';
import { useFormikContext, Field } from 'formik';
import { IFormValues } from '../DealRentModal';
import * as styles from '../index.css';

export const IsAgent = () => {
  const { values } = useFormikContext<IFormValues>();

  return (
    <div {...mergeStyles(styles['field'], styles['span-columns'])}>
      <Field
        name="isAgent"
        as={Checkbox}
        checked={values.isAgent}
        custom={{ label: 'Я агент, подбираю квартиру для клиента', mediaType: 'desktop' }}
      />
    </div>
  );
};
